import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";
import { LISTING_WIZARD_STEPS } from "ui/modules/sales/pages/listings/components/ListingEditCard/consts";

import { LISTING_INTRO_DEFAULT_STEP, LISTING_INTRO_EDIT_TEXT, LISTING_INTRO_TEXTS } from "./consts";
import AdDataScene from "./scenes/AdDataScene";
import AdditionalInfoScene from "./scenes/AdditionalInfoScene";
import ChannelsScene from "./scenes/ChannelsScene";
import PicturesScene from "./scenes/PicturesScene";
import PreviewScene from "./scenes/PreviewScene";
import PriceScene from "./scenes/PriceScene";
import { ListingIntroProps, ListingSceneProps } from "./types";

/** Scena za svaki korak čarobnjaka oglasa, po koraku iz `LISTING_WIZARD_STEPS`. */
const STEP_SCENES: Record<number, React.FC<ListingSceneProps>> = {
  [LISTING_WIZARD_STEPS.channelPicker]: ChannelsScene,
  [LISTING_WIZARD_STEPS.marketplace]: AdDataScene,
  [LISTING_WIZARD_STEPS.additionalInfo]: AdditionalInfoScene,
  [LISTING_WIZARD_STEPS.pictures]: PicturesScene,
  [LISTING_WIZARD_STEPS.price]: PriceScene,
  [LISTING_WIZARD_STEPS.preview]: PreviewScene,
};

/**
 * Lijevi panel čarobnjaka oglasa: za svaki korak vlastita scena s karticama koje prikazuju
 * vozilo, odabrane oglasnike, fotografije i cijenu, a ispod objašnjenje koraka.
 */
const ListingIntro: React.FC<ListingIntroProps> = ({ formValues, stepCurrent, stepCount, isEdit }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : LISTING_INTRO_DEFAULT_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = isEdit && stepKey === LISTING_INTRO_DEFAULT_STEP ? LISTING_INTRO_EDIT_TEXT : LISTING_INTRO_TEXTS[stepKey];

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepCurrent}
      stepCount={stepCount}
    >
      <Scene formValues={formValues} />
    </ShowcaseIntro>
  );
};

export default memo(ListingIntro);
